<div class="are-you-sure is-closable">
    <kendo-dialog title="Please confirm" (close)="closeDialog(false)">
        <h3>{{titleTextOverride}}</h3>
        <kendo-dialog-actions [layout]="'end'">
            <button kendoButton
                id="are-you-sure-yes" 
                (click)="handleYes()"  
                (keyup.enter)="handleYes()"
                themeColor="primary"  
            >{{yesTextOverride}}</button>
            <button kendoButton
                id="are-you-sure-yes" 
                (click)="handleNo()"  
                (keyup.enter)="handleNo()"  
            >{{noTextOverride}}</button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>
